import React, {useEffect, useState} from 'react';
import InterviewsTable from "./InterviewsTable";
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Highlighter from "./Highlighter";
import AppBar from "./AppBar";
import Snackbar from "@material-ui/core/Snackbar";
import {cyan, orange} from "@material-ui/core/colors";


export default function InterviewsComponent(props) {
    const [interviewsResponse, setInterviewsResponse] = useState(null);
    const [chosenCategories, setChosenCategories] = useState(null);
    const [showAssignmentsError, setShowAssignmentsError] = React.useState(false);
    const [showToast, setShowToast] = React.useState(false);
    const [showRedoToast, setShowRedoToast] = React.useState(false);
    const [showErrorToast, setShowErrorToast] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [showAlertToast, setShowAlertToast] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState("");

    const theme = createMuiTheme({
        palette: {
            primary: cyan,
            secondary: orange,
        },
    });

    // login data
    const [user] = useState(null);
    const [authenticated] = useState(() => {
        if (props.location.state) {
            return props.location.state.isAuthenticated;
        }
        // Teamsessions page was opened in server side.
        return null;
    });

    const handleCloseAssignmentsError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowAssignmentsError(false);
    };

    const handleCloseOfRedoToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowRedoToast(false);
    };

    useEffect(() => {
            // if the page wasn't opened by client side and also authenticated
            if (!authenticated) {
                window.location.replace(process.env.REACT_APP_URL);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);

    const fetchData = async function fetchData() {
        const getInterviewsUrl = process.env.REACT_APP_BACKEND_URL + "/sessions/interviews/" + props.location.state.id;
        const res = await fetch(getInterviewsUrl, {
            method: "GET",
            credentials: "include"});
        // unauthorized user
        if (res.status === 401) {
            window.location.replace(process.env.REACT_APP_URL);
        }
        res
            .json()
            .then(res => {
                setInterviewsResponse(res);
                setShowAssignmentsError(res.acquaintances.length !== 0);
            })
    };

    // display an empty page until authentication
    if (!authenticated) {
        return <div></div>;
    }

    if (!interviewsResponse) {
        fetchData();
        return (
            <ThemeProvider theme={theme}>
                <AppBar isHomePageInput={false} titleData={props.location.state.appBarData}
                        sessionId={props.location.state.id} currentView={"Interviews"} authenticated={authenticated}
                        user={user} data={interviewsResponse}/>
                <LinearProgress/>
            </ThemeProvider>
        )
    }

    const highlightPersons = (updatedChosenCategories) => {
        setChosenCategories(updatedChosenCategories);
    };

    const calcNumberOfCandidates = interviewsResponse =>
        interviewsResponse.classes.map(classData => Object.keys(classData.interviews).length).reduce((a, b) => a + b);

    const calcNumberOfReviewers = interviewsResponse =>
        interviewsResponse.classes.map(classData => classData.reviewers.length).reduce((a, b) => a + b);

    const callbackShowToast = () => {
        setShowToast(true);
        setInterviewsResponse(null);
        //fetchData();
    };


    const handleCloseOfToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowToast(false);
    };

    const callbackShowErrorToast = (toastErrorMesage) => {
        setErrorMessage(toastErrorMesage);
        setShowErrorToast(true);
    };

    const callbackShowAlertToast = (toastMesage) => {
        setAlertMessage(toastMesage);
        setShowAlertToast(true);
    };

    const handleCloseOfAlertToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowAlertToast(false);
    };

    const callbackShowRedoToast = () => {
        setShowRedoToast(true);
        setInterviewsResponse(null);
        fetchData();
    };

    const handleCloseOfErrorToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowErrorToast(false);
    };

    return (
        <ThemeProvider theme={theme}>
            <AppBar isHomePageInput={false} titleData={props.location.state.appBarData}
                    sessionId={props.location.state.id} currentView={"Interviews"} authenticated={authenticated}
                    user={user} data={interviewsResponse} callbackShowRedoToast={callbackShowRedoToast}/>
            <Highlighter data={interviewsResponse.filters} buttonClickCallback={highlightPersons}
                         chosenCategories={chosenCategories} currentView={"Teams"}
                         numClasses={interviewsResponse.classes.length}
                         calcNumberOfCandidates={calcNumberOfCandidates(interviewsResponse)}
                         calcNumberOfReviewers={calcNumberOfReviewers(interviewsResponse)}/>
            {/*true if there is a reviewer who knows a candidate in the same class*/}
            {showAssignmentsError ? (<Alert severity="error" onClose={handleCloseAssignmentsError}
                                            style={{direction: "rtl"}}>
                <div style={{width: "90vw", paddingRight: "1vw"}}>
                    <AlertTitle style={{direction: "rtl"}}>שגיאה בשיבוץ</AlertTitle>
                    {interviewsResponse.acquaintances.map((acquaintancesOfReviewer, aIndex) => {
                        return <div key={aIndex}> בכיתה {acquaintancesOfReviewer.class} המעריכ\ה <b>{acquaintancesOfReviewer.reviewer_name}</b> מכיר\ה
                            {acquaintancesOfReviewer.acquaintances_candidates.map((candidate, index) => {
                                return <span key={index}>
                                    {index === acquaintancesOfReviewer.acquaintances_candidates.length - 1
                                    && acquaintancesOfReviewer.acquaintances_candidates.length > 1 ? " ואת " : " את "}
                                    <b>{candidate.candidate_name}</b>
                                    {candidate.isFromHome ? " מהכרות קודמת " : " מהתרגילים "}</span>
                            })}
                        </div>
                    })}
                </div>
            </Alert>) : ""
            }
            <InterviewsTable interviewsData={interviewsResponse} inputChosenCategories={chosenCategories}
                             callbackShowToast={callbackShowToast}
                             callbackShowErrorToast={callbackShowErrorToast}
                             callbackShowMessageToast={callbackShowAlertToast}/>
            {/*Success toast*/}
            <Snackbar open={showToast} autoHideDuration={4000} onClose={handleCloseOfToast}>
                <Alert onClose={handleCloseOfToast} severity="success">
                    !העריכה הסתיימה בהצלחה
                </Alert>
            </Snackbar>

            {/*Failure toast*/}
            <Snackbar open={showErrorToast} autoHideDuration={4000} onClose={handleCloseOfErrorToast}>
                <Alert onClose={handleCloseOfErrorToast} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>

            {/*Alert toast*/}
            <Snackbar open={showAlertToast} autoHideDuration={4000} onClose={handleCloseOfAlertToast}>
                <Alert onClose={handleCloseOfAlertToast} severity="warning">
                    {alertMessage}
                </Alert>
            </Snackbar>

            {/*Success toast of redo action*/}
            <Snackbar open={showRedoToast} autoHideDuration={4000} onClose={handleCloseOfRedoToast}>
                <Alert onClose={handleCloseOfRedoToast} severity="success">
                    !שיבוץ מחדש הסתיים בהצלחה
                </Alert>
            </Snackbar>
        </ThemeProvider>
    );
}
